export default (function () {
  var isResizeble = false;
  $(".active_filter").click(function (e) {
    e.preventDefault();
    var active_element = $(".year li.active");
    var list_content = $(".active_list");
    $(this).toggleClass('active');
    $(".filter_posts").slideToggle();
    list_content.toggleClass('active');

    if (list_content.hasClass('active')) {
      list_content.html('');
    }

    if (isResizeble) {
      $.each(active_element, function () {
        var name = $(this).html();

        if ($(this)[0].hasAttribute('data-date')) {
          var date = $(this).data('date');
          list_content.append(renderFilter(name, 'data-date', date));
        } else if ($(this)[0].hasAttribute('data-customer')) {
          var customer = $(this).data('customer');
          list_content.append(renderFilter(name, 'data-customer', customer));
        }
      });
    }

    isResizeble = false;
    $('.active_list li').click(function () {
      var dataDate = $(this).data('date');
      var dataCustomer = $(this).data('customer');
      $(this).remove();

      if (dataDate) {
        $(".year li[data-date='" + dataDate + "']").trigger('click');
      } else if (dataCustomer) {
        $(".year li[data-customer='" + dataCustomer + "']").trigger('click');
      }
    });
  });

  function renderFilter(name, attrName, attrValue) {
    return "<li ".concat(attrName, "=\"").concat(attrValue, "\">").concat(name, "</li>");
  } // $(window).on('load', function () {
  //     var queryString = window.location.search.substring(1);
  //
  //     if (queryString) {
  //         $(".year li[data-tag='" + queryString + "']").trigger('click');
  //         var active_element = $(".year li.active");
  //         var list_content = $(".active_list");
  //         var $el = active_element.clone();
  //         list_content.html($el);
  //     }
  // });


  $(".year li").click(function () {
    isResizeble = true;
    var list_content = $(".active_list");

    if ($(this).parent().hasClass('single-choice')) {
      $(this).siblings().removeClass('active');
    }

    $(this).toggleClass('active');
    var date = '';
    var customer = '';
    var item = $(".filter_posts li.active");
    $.each(item, function () {
      var dataDate = $(this).data('date');
      var dataCustomer = $(this).data('customer'); // console.log(dataClient);

      if (dataDate) {
        date = dataDate;
      }

      if (dataCustomer) {
        customer += dataCustomer + ',';
      }
    });
    var data = {
      'action': 'filter_post_asb',
      'date': date,
      'customer': customer.slice(0, -1)
    }; // console.log(data);

    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      data: data,
      type: 'POST',
      success: function success(data) {
        $(".projects_filtered .row").html(data);
      }
    });
  });
  $(".year li.active").click(function () {
    $(this).removeClass('active');
  });
});